/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type { GoogleRpcStatus, V2beta1ListRunsResponse, V2beta1Run } from '../models/index';
import {
  GoogleRpcStatusFromJSON,
  GoogleRpcStatusToJSON,
  V2beta1ListRunsResponseFromJSON,
  V2beta1ListRunsResponseToJSON,
  V2beta1RunFromJSON,
  V2beta1RunToJSON,
} from '../models/index';

export interface ArchiveRunRequest {
  run_id: string;
  experiment_id?: string;
}

export interface CreateRunRequest {
  run: V2beta1Run;
  experiment_id?: string;
}

export interface DeleteRunRequest {
  run_id: string;
  experiment_id?: string;
}

export interface GetRunRequest {
  run_id: string;
  experiment_id?: string;
}

export interface ListRunsRequest {
  namespace?: string;
  experiment_id?: string;
  page_token?: string;
  page_size?: number;
  sort_by?: string;
  filter?: string;
}

export interface RetryRunRequest {
  run_id: string;
  experiment_id?: string;
}

export interface TerminateRunRequest {
  run_id: string;
  experiment_id?: string;
}

export interface UnarchiveRunRequest {
  run_id: string;
  experiment_id?: string;
}

/**
 *
 */
export class RunServiceApi extends runtime.BaseAPI {
  /**
   * Archives a run in an experiment given by run ID and experiment ID.
   */
  async archiveRunRaw(
    requestParameters: ArchiveRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['run_id'] == null) {
      throw new runtime.RequiredError(
        'run_id',
        'Required parameter "run_id" was null or undefined when calling archiveRun().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['experiment_id'] != null) {
      queryParameters['experiment_id'] = requestParameters['experiment_id'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v2beta1/runs/{run_id}:archive`;
    urlPath = urlPath.replace(
      `{${'run_id'}}`,
      encodeURIComponent(String(requestParameters['run_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Archives a run in an experiment given by run ID and experiment ID.
   */
  async archiveRun(
    run_id: string,
    experiment_id?: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.archiveRunRaw(
      { run_id: run_id, experiment_id: experiment_id },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Creates a new run in an experiment specified by experiment ID. If experiment ID is not specified, the run is created in the default experiment.
   */
  async createRunRaw(
    requestParameters: CreateRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<V2beta1Run>> {
    if (requestParameters['run'] == null) {
      throw new runtime.RequiredError(
        'run',
        'Required parameter "run" was null or undefined when calling createRun().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['experiment_id'] != null) {
      queryParameters['experiment_id'] = requestParameters['experiment_id'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v2beta1/runs`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: V2beta1RunToJSON(requestParameters['run']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => V2beta1RunFromJSON(jsonValue));
  }

  /**
   * Creates a new run in an experiment specified by experiment ID. If experiment ID is not specified, the run is created in the default experiment.
   */
  async createRun(
    run: V2beta1Run,
    experiment_id?: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<V2beta1Run> {
    const response = await this.createRunRaw(
      { run: run, experiment_id: experiment_id },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Deletes a run in an experiment given by run ID and experiment ID.
   */
  async deleteRunRaw(
    requestParameters: DeleteRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['run_id'] == null) {
      throw new runtime.RequiredError(
        'run_id',
        'Required parameter "run_id" was null or undefined when calling deleteRun().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['experiment_id'] != null) {
      queryParameters['experiment_id'] = requestParameters['experiment_id'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v2beta1/runs/{run_id}`;
    urlPath = urlPath.replace(
      `{${'run_id'}}`,
      encodeURIComponent(String(requestParameters['run_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Deletes a run in an experiment given by run ID and experiment ID.
   */
  async deleteRun(
    run_id: string,
    experiment_id?: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.deleteRunRaw(
      { run_id: run_id, experiment_id: experiment_id },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Finds a specific run by ID.
   */
  async getRunRaw(
    requestParameters: GetRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<V2beta1Run>> {
    if (requestParameters['run_id'] == null) {
      throw new runtime.RequiredError(
        'run_id',
        'Required parameter "run_id" was null or undefined when calling getRun().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['experiment_id'] != null) {
      queryParameters['experiment_id'] = requestParameters['experiment_id'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v2beta1/runs/{run_id}`;
    urlPath = urlPath.replace(
      `{${'run_id'}}`,
      encodeURIComponent(String(requestParameters['run_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => V2beta1RunFromJSON(jsonValue));
  }

  /**
   * Finds a specific run by ID.
   */
  async getRun(
    run_id: string,
    experiment_id?: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<V2beta1Run> {
    const response = await this.getRunRaw(
      { run_id: run_id, experiment_id: experiment_id },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Finds all runs in an experiment given by experiment ID. If experiment id is not specified, finds all runs across all experiments.
   */
  async listRunsRaw(
    requestParameters: ListRunsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<V2beta1ListRunsResponse>> {
    const queryParameters: any = {};

    if (requestParameters['namespace'] != null) {
      queryParameters['namespace'] = requestParameters['namespace'];
    }

    if (requestParameters['experiment_id'] != null) {
      queryParameters['experiment_id'] = requestParameters['experiment_id'];
    }

    if (requestParameters['page_token'] != null) {
      queryParameters['page_token'] = requestParameters['page_token'];
    }

    if (requestParameters['page_size'] != null) {
      queryParameters['page_size'] = requestParameters['page_size'];
    }

    if (requestParameters['sort_by'] != null) {
      queryParameters['sort_by'] = requestParameters['sort_by'];
    }

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v2beta1/runs`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      V2beta1ListRunsResponseFromJSON(jsonValue),
    );
  }

  /**
   * Finds all runs in an experiment given by experiment ID. If experiment id is not specified, finds all runs across all experiments.
   */
  async listRuns(
    namespace?: string,
    experiment_id?: string,
    page_token?: string,
    page_size?: number,
    sort_by?: string,
    filter?: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<V2beta1ListRunsResponse> {
    const response = await this.listRunsRaw(
      {
        namespace: namespace,
        experiment_id: experiment_id,
        page_token: page_token,
        page_size: page_size,
        sort_by: sort_by,
        filter: filter,
      },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Re-initiates a failed or terminated run.
   */
  async retryRunRaw(
    requestParameters: RetryRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['run_id'] == null) {
      throw new runtime.RequiredError(
        'run_id',
        'Required parameter "run_id" was null or undefined when calling retryRun().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['experiment_id'] != null) {
      queryParameters['experiment_id'] = requestParameters['experiment_id'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v2beta1/runs/{run_id}:retry`;
    urlPath = urlPath.replace(
      `{${'run_id'}}`,
      encodeURIComponent(String(requestParameters['run_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Re-initiates a failed or terminated run.
   */
  async retryRun(
    run_id: string,
    experiment_id?: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.retryRunRaw(
      { run_id: run_id, experiment_id: experiment_id },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Terminates an active run.
   */
  async terminateRunRaw(
    requestParameters: TerminateRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['run_id'] == null) {
      throw new runtime.RequiredError(
        'run_id',
        'Required parameter "run_id" was null or undefined when calling terminateRun().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['experiment_id'] != null) {
      queryParameters['experiment_id'] = requestParameters['experiment_id'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v2beta1/runs/{run_id}:terminate`;
    urlPath = urlPath.replace(
      `{${'run_id'}}`,
      encodeURIComponent(String(requestParameters['run_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Terminates an active run.
   */
  async terminateRun(
    run_id: string,
    experiment_id?: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.terminateRunRaw(
      { run_id: run_id, experiment_id: experiment_id },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Restores an archived run in an experiment given by run ID and experiment ID.
   */
  async unarchiveRunRaw(
    requestParameters: UnarchiveRunRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['run_id'] == null) {
      throw new runtime.RequiredError(
        'run_id',
        'Required parameter "run_id" was null or undefined when calling unarchiveRun().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['experiment_id'] != null) {
      queryParameters['experiment_id'] = requestParameters['experiment_id'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v2beta1/runs/{run_id}:unarchive`;
    urlPath = urlPath.replace(
      `{${'run_id'}}`,
      encodeURIComponent(String(requestParameters['run_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Restores an archived run in an experiment given by run ID and experiment ID.
   */
  async unarchiveRun(
    run_id: string,
    experiment_id?: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.unarchiveRunRaw(
      { run_id: run_id, experiment_id: experiment_id },
      initOverrides,
    );
    return await response.value();
  }
}
